import { IPageAwareState } from "../platform/components/Page/Contracts";
import { ITestAwareState } from "../views/TestView/Contracts";
import { IFeatureManagementAwareState } from "../platform/FeatureManagement/Contracts";

export interface IUhfViewState
    extends IPageAwareState,
        IFeatureManagementAwareState,
        ITestAwareState {}

export class Area {
    public static Test = "Test";
    public static Documentation = "Documentation";
}

export class TelemetryProperties {
    public static Action = "Action";
    public static ErrorMessage = "ErrorMessage";
}
